import { forwardRef, useId, useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Field } from "./ui";
import "./password-field.css";

export const PasswordField = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & { label: string; hint?: string; error?: string }>(function PasswordField({ label, id: providedId, ...props }, ref) {
  const [visible, setVisible] = useState(false), generatedId = useId();
  const id = providedId ?? generatedId;
  return <div className="password-control">
    <Field {...props} label={label} id={id} ref={ref} type={visible ? "text" : "password"} />
    <button className="password-control__toggle" type="button" aria-label={`${visible ? "隐藏" : "显示"}${label}`} aria-pressed={visible} aria-controls={id} disabled={props.disabled} onClick={() => setVisible(value => !value)}>{visible ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}</button>
  </div>;
});
